import { Image, ImageProps } from 'tamagui'

export const GrayImage = ({ ...rest }: ImageProps) => {
  return <Image alt="" {...rest} style={{ filter: 'grayscale(1)' }} />
}
